import { all } from "redux-saga/effects";
import { loginWorkerWatcher } from "./authSaga";
import { createCategoryWatcher, deleteCategoryWatcher, editCategoryWatcher, listCategoryWatcher, viewCategoryWatcher } from "./categorySaga";
import { categoryDropdownWatcher, createProductWatcher, deleteProductWatcher, editProductWatcher, listProductWatcher, uploadImageWatcher, viewProductWatcher } from "./productSaga";
import { addStockReturnWatcher, addStockWatcher, customersDropdownWatcher, deleteInventoryWatcher, editInventoryWatcher, inventoryListWatcher, newStockListWatcher, newStockReturnListWatcher, productDropdownWatcher, purchasedProductsDropdownWatcher, removeStockReturnWatcher, removeStockWatcher, routesDropdownWatcher, stockReportWatcher, updateInventoryStockReturnWatcher, updateInventoryWatcher } from "./inventorySaga";
import { completeRouteWatcher, createRouteWatcher, dropersDropdownWatcher, editRouteWatcher, listRouteWatcher, productsRouteListWatcher, storesDropdownWatcher, viewRouteWatcher } from "./routeSaga";
import { dashboardLowStockProductsWatcher, dashboardMonthlySalesWatcher, dashboardOutOfStockProductsWatcher, dashboardWatcher } from "./dashboardSaga";
import { resetPasswordWatcher, saveSettingsWatcher, uploadLogoWatcher, viewSettingsWatcher } from "./settingsSaga";
import { createStoreWatcher, editStoreWatcher, exportStoresWatcher, listStoreWatcher, uploadStoreImageWatcher, viewStoreWatcher } from "./storeSaga";
import { createDroperWatcher, editDroperWatcher, enableDisableDroperWatcher, listDroperWatcher, resetPasswordDroperWatcher, uploadDroperImageWatcher, viewDroperWatcher } from "./droperSaga";
import { approveRejectOrderWatcher, createOrderWatcher, editOrderWatcher, listOrderWatcher, viewOrderWatcher } from "./orderSaga";
import { inventoryReportWatcher, productSalesReportWatcher, stockInReportWatcher } from "./reportSaga";
import { addRouteCreditWatcher, createCreditWatcher, editRouteCreditWatcher, listCreditWatcher, routesListCreditWatcher, viewCreditWatcher } from "./creditSaga";


export default function* rootSaga() {
    yield all([
        /**Watcher functions to be added here */
        loginWorkerWatcher(),

        createCategoryWatcher(),
        editCategoryWatcher(),
        deleteCategoryWatcher(),
        listCategoryWatcher(),
        viewCategoryWatcher(),

        createProductWatcher(),
        editProductWatcher(),
        deleteProductWatcher(),
        listProductWatcher(),
        viewProductWatcher(),
        uploadImageWatcher(),
        categoryDropdownWatcher(),

        inventoryListWatcher(),
        newStockListWatcher(),
        addStockWatcher(),
        removeStockWatcher(),
        productDropdownWatcher(),
        updateInventoryWatcher(),
        editInventoryWatcher(),
        deleteInventoryWatcher(),
        stockReportWatcher(),

        createRouteWatcher(),
        editRouteWatcher(),
        listRouteWatcher(),
        viewRouteWatcher(),
        productsRouteListWatcher(),
        completeRouteWatcher(),
        dropersDropdownWatcher(),
        storesDropdownWatcher(),

        dashboardWatcher(),
        dashboardMonthlySalesWatcher(),
        dashboardOutOfStockProductsWatcher(),
        dashboardLowStockProductsWatcher(),

        viewSettingsWatcher(),
        uploadLogoWatcher(),
        saveSettingsWatcher(),
        resetPasswordWatcher(),

        newStockReturnListWatcher(),
        addStockReturnWatcher(),
        removeStockReturnWatcher(),
        updateInventoryStockReturnWatcher(),
        routesDropdownWatcher(),
        customersDropdownWatcher(),
        purchasedProductsDropdownWatcher(),

        createStoreWatcher(),
        editStoreWatcher(),
        listStoreWatcher(),
        viewStoreWatcher(),
        uploadStoreImageWatcher(),
        exportStoresWatcher(),

        createDroperWatcher(),
        editDroperWatcher(),
        listDroperWatcher(),
        viewDroperWatcher(),
        uploadDroperImageWatcher(),
        enableDisableDroperWatcher(),
        resetPasswordDroperWatcher(),
        createOrderWatcher(),
        editOrderWatcher(),
        approveRejectOrderWatcher(),
        listOrderWatcher(),
        viewOrderWatcher(),

        inventoryReportWatcher(),
        stockInReportWatcher(),
        productSalesReportWatcher(),

        createCreditWatcher(),
        addRouteCreditWatcher(),
        editRouteCreditWatcher(),
        listCreditWatcher(),
        viewCreditWatcher(),
        routesListCreditWatcher()
    ]);
}
